import axios from "../../utils/axios"

export const fetchRelatedPosts = async ({ tags, id }) => {
    const query = tags?.length > 0
        ? tags.map((tag) => `tags_like=${tag}`).join("&") +
        `&id_ne=${id}`
        : `id_ne=${id}`;
    const response = await axios.get(`/blogs?${query}`)
    const data = response.data
    if (data) {

        return response.data
    } else {
        return []
    }

}
